<a
  *ngIf="id && name && competitionId"
  [routerLink]="['/ccpc/competitions/', competitionId, 'tournaments', id]"
  >{{ name }}</a
>
